/**
 * Document Service - API client for the generic staff/student document repository
 */
import api, { API_URL } from '../utils/api';

const documentService = {
  list: async (ownerType, ownerId) => {
    try {
      return await api.get('/api/documents', { params: { owner_type: ownerType, owner_id: ownerId } });
    } catch (error) {
      console.error('Error fetching documents:', error);
      throw error;
    }
  },

  upload: async (ownerType, ownerId, category, title, file, accessRoles) => {
    try {
      const formData = new FormData();
      formData.append('owner_type', ownerType);
      formData.append('owner_id', ownerId);
      formData.append('category', category);
      if (title) formData.append('title', title);
      if (accessRoles) formData.append('access_roles', accessRoles);
      formData.append('file', file);
      return await api.post('/api/documents', formData);
    } catch (error) {
      console.error('Error uploading document:', error);
      throw error;
    }
  },

  remove: async (documentId) => {
    try {
      return await api.delete(`/api/documents/${documentId}`);
    } catch (error) {
      console.error('Error deleting document:', error);
      throw error;
    }
  },

  download: async (documentId, filename) => {
    const token = api.getToken();
    const response = await fetch(`${API_URL}/api/documents/${documentId}/download`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!response.ok) {
      let detail = 'Download failed';
      try { detail = (await response.json())?.detail || detail; } catch (_) { /* not JSON */ }
      throw new Error(detail);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default documentService;
